import { render, staticRenderFns } from "./divinity.vue?vue&type=template&id=6717d83e&scoped=true&"
import script from "./divinity.vue?vue&type=script&lang=js&"
export * from "./divinity.vue?vue&type=script&lang=js&"
import style0 from "./divinity.vue?vue&type=style&index=0&id=6717d83e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717d83e",
  null
  
)

export default component.exports